export const TARGET_URL_MIN_LENGTH = 6;
export const TARGET_URL_MAX_LENGTH = 2000;
